import { FaLock } from "react-icons/fa";
import { useIconSize } from "@app/hooks";
import TranslatableText from "@components/translations/TranslatableText";
import { TranslationKey } from "@typedefs/modulesInterfaces";

interface MapLockOverlayProps {
  message: string;
  translationKey?: string;
  translationParams?: Record<string, string>;
  subtitleTranslationKey?: string;
  subtitleTranslationParams?: Record<string, string>;
}

const MapLockOverlay = ({
  message,
  translationKey,
  translationParams,
  subtitleTranslationKey,
  subtitleTranslationParams,
}: MapLockOverlayProps) => {
  const iconSize = useIconSize(48);

  return (
    <div
      className="map-lock-overlay"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        zIndex: 10,
        pointerEvents: "none",
      }}
    >
      <FaLock size={iconSize} color="var(--tertiary-dark)" />
      <div
        style={{
          textAlign: "center",
          fontSize: "16px",
          fontWeight: 500,
          color: "var(--darker-gray)",
          maxWidth: "400px",
          padding: "0 16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {translationKey ? (
          <TranslatableText
            translationKey={translationKey as TranslationKey}
            translationParams={translationParams}
          />
        ) : (
          message
        )}
        {subtitleTranslationKey && (
          <span
            style={{
              fontSize: "14px",
              fontWeight: 400,
              color: "var(--midtone-gray)",
              opacity: 0.9,
            }}
          >
            <TranslatableText
              translationKey={subtitleTranslationKey as TranslationKey}
              translationParams={subtitleTranslationParams}
            />
          </span>
        )}
      </div>
    </div>
  );
};

export default MapLockOverlay;

